import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b131c5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-start" }

import {computed} from 'vue'

type charData = {
  id: number,
  charName: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextWriteRender',
  props: {
    text: {},
    indexCurrentChar: {},
    invalidChar: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



// Вычисление и заполнения массива для построения букв для ввода
let computedCharData = computed(() => {
  let charEnum: Array<charData> = []

  props.text.forEach((char: string, index: number) => {
    charEnum.push({
      id: index,
      charName: char
    })
  })

  return charEnum
})


// Конец


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedCharData), ({id,charName}) => {
      return (_openBlock(), _createElementBlock("span", {
        key: id,
        class: _normalizeClass(["char", [
          {'custom-select': id === _ctx.indexCurrentChar},
          {'custom-select--uncorrect' : _ctx.invalidChar && id === _ctx.indexCurrentChar }
        ]])
      }, _toDisplayString(charName), 3))
    }), 128))
  ]))
}
}

})